import type { Kpi } from "./types";

export const CRITICAL_KPI_ID = "critical_kpi";
export const CRITICAL_KPI_NAME = "Critical KPI";
export const CRITICAL_KPI_DESCRIPTION =
  "Static KPI that groups alerts which must immediately degrade service health.";
export const CRITICAL_KPI_WEIGHT = 100;
export const CRITICAL_KPI_THRESHOLDS = {
  warning: 1,
  critical: 1,
} as const;

export const isCriticalKpiId = (kpiId: string | undefined): boolean => {
  return (kpiId ?? "") === CRITICAL_KPI_ID;
};

export const buildCriticalKpi = (alertIds: string[]): Kpi => {
  const deduplicatedAlertIds = Array.from(new Set(alertIds));

  return {
    id: CRITICAL_KPI_ID,
    name: CRITICAL_KPI_NAME,
    description: CRITICAL_KPI_DESCRIPTION,
    alerts: deduplicatedAlertIds,
    alertConnections: deduplicatedAlertIds.map((alertId) => ({
      alertId,
      weight: 0,
    })),
    weight: CRITICAL_KPI_WEIGHT,
    system: true,
    thresholds: {
      warning: CRITICAL_KPI_THRESHOLDS.warning,
      critical: CRITICAL_KPI_THRESHOLDS.critical,
    },
    metrics: {},
  };
};
